<template>
  <v-app style="font-family: Vazirmatn" id="inspire">
    <v-main>
      <router-view />
    </v-main>
  </v-app>
</template>

<script>
export default {
  name: "App",

  data: () => ({
    //
  }),
};
</script>
<style>
.v-img__img {
  padding: 5px;
  margin-right: 10px;
  width: unset !important;
  left: unset !important;
}
.v-responsive.v-img {
  flex: 0 0 auto;
}
.v-toolbar-title {
  font-size: 3.2vw !important;
}
@media (min-width: 768px) {
  .v-toolbar-title {
    font-size: 1.25em !important;
  }
}
</style>
